<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {}
  },
  mounted() {
    if (process.env.NODE_ENV !== 'development') {
      this.loadBeaconScript();

      // this.user.organization_id === 1 ? '9759d27a-c734-4ce1-b757-dc575de5ab7d' :
      const beaconId = "324c3420-7842-4a11-9562-a076766f8782";

      window.Beacon('init', beaconId);

      window.Beacon('config', {
        contactForm: {
          showSubject: false
        },
        hideFABOnMobile: true,
        hideFABLabelOnMobile: true,
      });

      window.Beacon('identify', {
        name: this.attendee.name ? this.attendee.name : '',
        email: this.attendee.email ? this.attendee.email : ''
      });
    }
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee'])
  },
  methods: {
    loadBeaconScript() {
      !function (e, t, n) {
        function a() {
          var e = t.getElementsByTagName("script")[0], n = t.createElement("script");
          n.type = "text/javascript", n.async = !0, n.src = "https://beacon-v2.helpscout.net", e.parentNode.insertBefore(n, e)
        }

        if (e.Beacon = n = function (t, n, a) {
          e.Beacon.readyQueue.push({method: t, options: n, data: a})
        }, n.readyQueue = [], "complete" === t.readyState) return a();
        e.attachEvent ? e.attachEvent("onload", a) : e.addEventListener("load", a, !1)
      }(window, document, window.Beacon || function () {
      });
    }
  }
}
</script>
